import gql from 'graphql-tag'

export const fetchNewsCategoriesSelect = () => {
	return {
		query: gql`
			{
				categories: news_categories(
					where: { active: { _eq: true } }
					order_by: { category_name: asc }
				) {
					id
					category_name
				}
			}
		`
	}
}
